import { render, staticRenderFns } from "./BasePrimaryActionButton.vue?vue&type=template&id=763c1ae6"
import script from "./BasePrimaryActionButton.vue?vue&type=script&lang=js"
export * from "./BasePrimaryActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports